import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import './huntCard.css';
import preciseFormat from '../../utils/preciseFormat';
import { AuthContext } from '../../context/AuthContext';
import PlayerAvatars from '../playerAvatars/PlayerAvatars';
import BadgeList from '../badgeList/BadgeList';

const HuntCard = ({ hunt, onShare }) => {
  const { player } = useContext(AuthContext);
  const isNew = (() => {
    const now = new Date();
    const created = new Date(hunt.createdAt);
    const diffDays = Math.floor((now - created) / (1000 * 60 * 60 * 24));
    return diffDays <= 7;
  })();

  const isUpcoming = hunt.startDate && new Date(hunt.startDate) > new Date();
  const countdown = isUpcoming && preciseFormat(hunt.startDate);
  // Rolling number effect for playerCount
  const [displayedCount, setDisplayedCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = Array.isArray(hunt.players) ? hunt.players.length : 0;
    if (start === end) {
      setDisplayedCount(end);
      return;
    }
    const duration = 800; // ms
    const frameRate = 30; // ms per frame
    const totalFrames = Math.ceil(duration / frameRate);
    let frame = 0;

    const counter = setInterval(() => {
      frame++;
      const progress = Math.min(frame / totalFrames, 1);
      const current = Math.round(start + (end - start) * progress);
      setDisplayedCount(current);
      if (progress === 1) clearInterval(counter);
    }, frameRate);

    return () => clearInterval(counter);
  }, [hunt.players, hunt.players.length]);

  //   console.log('HuntCard', hunt._id, `/hunts/${hunt._id}`);
  // console.log('Hunt players:', hunt.players, 'player:', player.data.player._id);
  return (
    <div className="card shadow-sm h-100 position-relative border-success hunt-card-hover">
      <Link
        to={`/hunts/${hunt._id}`}
        className="text-decoration-none"
        aria-label={`View details for hunt ${hunt.name}`}
        title={`View and join ${hunt.name}`}
      >
        {hunt.imageUrl && (
          <img
            src={hunt.imageUrl}
            className="card-img-top"
            alt={`${hunt.name} Hunt Illustration`}
            style={{
              objectFit: 'cover',
              height: '180px',
              borderTopLeftRadius: '0.375rem',
              borderTopRightRadius: '0.375rem',
            }}
          />
        )}
      </Link>

      {(hunt.isFeatured || isNew) && (
        <span
          className="badge bg-warning text-dark position-absolute"
          style={{ top: '10px', left: '10px', zIndex: 2 }}
        >
          {hunt.isFeatured ? '🌟 Featured' : '🆕 New'}
        </span>
      )}
      {/* </Link> */}

      <div className="card-body d-flex flex-column">
        <h5 className="card-title text-primary fw-bold mb-1">{hunt.name}</h5>

        <p className="card-text small text-muted mb-1">
          {hunt.city && hunt.region ? `${hunt.city}, ${hunt.region}` : ''}
        </p>

        <p className="card-text mb-2 text-dark">{hunt.description}</p>

        {hunt.rewards && (
          <p className="card-text text-success small animate__animated animate__pulse animate__repeat-2">
            ⚡ XP & JGK Rewards: {hunt?.rewards?.xp || 0} XP
            {hunt?.rewards?.jgk ? `, ${hunt.rewards.jgk} JGK` : ''}
          </p>
        )}

        {isUpcoming && (
          <p className="card-text text-info small">
            ⏳ Starts in {countdown}
            <br />
            <span className="text-muted">
              (
              {new Date(hunt.startDate).toLocaleString(undefined, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })}
              )
            </span>
            <br />
            <span
              className="badge bg-warning text-dark"
              style={{ fontSize: 14 }}
            >
              Price: {hunt.priceInJGK} JGK
            </span>
          </p>
        )}

        <BadgeList badges={hunt.badges} maxDisplay={3} />
        {hunt.players && hunt.players.length > 0 && (
          <PlayerAvatars players={hunt.players} maxDisplay={9} />
        )}
        <div
          className="d-flex justify-content-between align-items-center mt-auto"
          style={{ gap: '1rem' }}
        >
          <span className="text-success fw-semibold">
            👥 {displayedCount.toLocaleString()} players
          </span>
          {hunt.players?.some((p) => p._id === player.data.player._id) ? (
            <Link
              to={`/hunts/${hunt._id}`}
              className="btn btn-sm btn-outline-primary px-3 animated-subscribe-btn"
              title={`Go to ${hunt.name}`}
            >
              🚀 Go to Hunt
            </Link>
          ) : (
            <Link
              to={`/hunts/${hunt._id}`}
              className="btn btn-sm btn-success px-3 animated-subscribe-btn"
              title={`Preview ${hunt.name}`}
            >
              👀 Preview Hunt
            </Link>
          )}
        </div>

        <div
          className="d-flex justify-content-between align-items-center mt-2"
          style={{ gap: '1rem' }}
        >
          <div className="text-muted small">
            Created {preciseFormat(hunt.createdAt)}
          </div>
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => onShare(hunt)}
            title="Share this hunt"
          >
            📤 Share
          </button>
        </div>
      </div>
    </div>
  );
};

export default HuntCard;
